var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "ListFilter",
                {
                  attrs: {
                    FILTER_ITEMS: _vm.FILTER_ITEMS,
                    handleSearch: _vm.handleSearch,
                  },
                },
                [
                  _vm.userType == 1
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "has-permi",
                              rawName: "v-has-permi",
                              value: ["admin:miniapp:add"],
                              expression: "['admin:miniapp:add']",
                            },
                          ],
                          staticClass: "mr10",
                          attrs: { size: "mini", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.handlerOpenEdit(0, "ADD")
                            },
                          },
                        },
                        [_vm._v("新增小程序")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "table",
              attrs: {
                data: _vm.tableData.list,
                size: "mini",
                "highlight-current-row": "",
                "header-cell-style": { fontWeight: "bold" },
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "ID", "min-width": "50" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "appLogo", label: "Logo", "min-width": "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-image", {
                          attrs: {
                            fit: "fill",
                            src: scope.row.appLogo,
                            "preview-src-list": [scope.row.appLogo],
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "appName",
                  label: "小程序名称",
                  "min-width": "180",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "customerName",
                  label: "归属客户",
                  "min-width": "180",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "originalId",
                  label: "原始ID",
                  "min-width": "160",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "appId", label: "APPID", "min-width": "160" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "payChannelStr",
                  label: "支付通道",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "merchantNo",
                  label: "商户号",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "merchantKey",
                  label: "商户key",
                  "min-width": "150",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "certSerialNo",
                  label: "证书序列号",
                  "min-width": "150",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "certPath",
                  label: "证书路径",
                  "min-width": "200",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "fudouCardId",
                  label: "关联默认卡片id",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "channelId",
                  label: "关联频道id",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "status", label: "状态", "min-width": "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              placeholder: "请选择",
                              size: "mini",
                              disabled: !_vm.checkPermi([
                                "admin:miniapp:updateStatus",
                              ]),
                            },
                            on: {
                              change: function ($event) {
                                return _vm.changeStatus(scope.row)
                              },
                            },
                            model: {
                              value: scope.row.status,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "status", $$v)
                              },
                              expression: "scope.row.status",
                            },
                          },
                          _vm._l(_vm.companyAppStatus, function (opt) {
                            return _c("el-option", {
                              key: opt.value,
                              attrs: {
                                label: opt.label,
                                value: opt.value,
                                disabled: opt.value === 1 || opt.value === 2,
                              },
                            })
                          }),
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "fudouStatus", label: "福卡分级" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-switch", {
                          attrs: {
                            "active-value": 1,
                            "inactive-value": 0,
                            "active-text": "开启",
                            "inactive-text": "关闭",
                            disabled: !_vm.checkPermi([
                              "admin:miniapp:updateFuDouStatus",
                            ]),
                          },
                          on: {
                            change: function ($event) {
                              return _vm.updateFuDouStatus(
                                scope.row.fudouStatus,
                                scope.row.customerId
                              )
                            },
                          },
                          model: {
                            value: scope.row.fudouStatus,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "fudouStatus", $$v)
                            },
                            expression: "scope.row.fudouStatus",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  "min-width": "380",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:miniapp:band:catagroy"],
                                expression: "['admin:miniapp:band:catagroy']",
                              },
                            ],
                            staticClass: "mr10",
                            attrs: { size: "small", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleBandCate(scope.row)
                              },
                            },
                          },
                          [_vm._v("绑定分类")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:miniapp:update"],
                                expression: "['admin:miniapp:update']",
                              },
                            ],
                            staticClass: "mr10",
                            attrs: { size: "small", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handlerOpenEdit(scope.row.id, "EDIT")
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:miniapp:payChannel"],
                                expression: "['admin:miniapp:payChannel']",
                              },
                            ],
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handlePayConfig(scope.row)
                              },
                            },
                          },
                          [_vm._v("支付通道配置")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:miniapp:sms"],
                                expression: "['admin:miniapp:sms']",
                              },
                            ],
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handleSmsConfig(scope.row)
                              },
                            },
                          },
                          [_vm._v("短信配置")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:miniapp:company-design"],
                                expression: "['admin:miniapp:company-design']",
                              },
                            ],
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDecorationManage(scope.row)
                              },
                            },
                          },
                          [_vm._v("装修管理")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:mini:program:tabber:edit"],
                                expression:
                                  "['admin:mini:program:tabber:edit']",
                              },
                            ],
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handleMenuBarManage(scope.row)
                              },
                            },
                          },
                          [_vm._v("菜单栏管理")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:miniapp:copy"],
                                expression: "['admin:miniapp:copy']",
                              },
                            ],
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handlerOpenEdit(scope.row.id, "COPY")
                              },
                            },
                          },
                          [_vm._v("复制为新小程序")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:wechat:code:download"],
                                expression: "['admin:wechat:code:download']",
                              },
                            ],
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.download(scope.row)
                              },
                            },
                          },
                          [_vm._v("代码下载")]
                        ),
                        _vm._v(" "),
                        scope.row.status == 1
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: ["admin:miniapp:delete"],
                                    expression: "['admin:miniapp:delete']",
                                  },
                                ],
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handlerDelete(scope.row.id)
                                  },
                                },
                              },
                              [_vm._v("删除")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            attrs: {
              "page-sizes": [20, 40, 60, 80],
              "page-size": _vm.pageData.limit,
              "current-page": _vm.pageData.page,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.tableData.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("EditCompanyapp", {
        ref: "EditCompanyappRef",
        on: { doRefresh: _vm.handleSearch },
      }),
      _vm._v(" "),
      _c("BandCateVue", { ref: "BandCateRef" }),
      _vm._v(" "),
      _c("decorationManageVue", {
        ref: "decorationManageVueRef",
        on: { refresh: _vm.handleSearch },
      }),
      _vm._v(" "),
      _c("SrcDownloadVue", {
        ref: "SrcDownloadVueRef",
        on: { refresh: _vm.handleSearch },
      }),
      _vm._v(" "),
      _c("AppPayConfig", {
        ref: "AppPayConfig",
        on: { refresh: _vm.handleSearch },
      }),
      _vm._v(" "),
      _c("SmsConfig", { ref: "SmsConfig", on: { refresh: _vm.handleSearch } }),
      _vm._v(" "),
      _c("MenuBarManage", {
        ref: "MenuBarManageRef",
        on: { refresh: _vm.handleSearch },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }